const Battery = () => (
  <svg
    width={9}
    height={16}
    viewBox="0 0 9 16"
    fill="none"
  >
    <path
      opacity={0.3}
      d="M6.19629 0.346191H3.19629V1.84619H1.69629C1.144 1.84619 0.696289 2.34987 0.696289 2.97119V14.2212C0.696289 14.8425 1.144 15.3462 1.69629 15.3462H7.69629C8.24857 15.3462 8.69629 14.8425 8.69629 14.2212V2.97119C8.69629 2.34987 8.24857 1.84619 7.69629 1.84619H6.19629V0.346191Z"
      fill="#5F6368"
    />
    <path
      d="M0.696295 8.34619C0.696288 8.92952 0.696289 13.7129 0.696289 14.2962C0.696289 14.8761 1.144 15.3462 1.69629 15.3462H7.69629C8.24857 15.3462 8.69629 14.8761 8.69629 14.2962C8.69629 13.7129 8.69629 8.92952 8.69629 8.34619H0.696295Z"
      fill="#5F6368"
    />
  </svg>
);
export default Battery;
